import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Mode} from "./mode.enum";
import {environment} from "../../environments/environment";


@Injectable({
  providedIn: 'root'
})
export class ModeService  {

  private url = "portalApiUrl/omnis/portal/mode";

  private mode: Mode;

  public async isReadOnly(): Promise<boolean> {
    if (!this.mode){
      this.mode = await this.http.get<Mode>(this.url).toPromise();
    }
    return this.mode !== Mode.NORMAL
  }

  constructor(private http: HttpClient) {
    this.mode = undefined;
  }



}
